import { handleEvent } from '../../helpers';

export default class {
  constructor(el) {
    this.el = el;
    this.gridItems = this.el.querySelectorAll('.entry-card');
  }

  init() {
    this.resizeAllGridItems();

    this.gridObserver = new MutationObserver(this.observerCallback);
    this.gridObserver.observe(this.el, {
      attributes: true, childList: true, subtree: true
    });

    this.urlObserver = new MutationObserver(this.urlObserverCallback);
    this.urlObserver.observe(document, {
      subtree: true, childList: true
    })

    this.handleEvents();
  }

  handleEvents() {

    this.resize = handleEvent('resize', {
      el: window,
      preventDefault: true,
      stopPropagation: true,
      callback: this.resizeAllGridItems.bind(this)
    });

  }

  resizeAllGridItems() {
    for(var i = 0; i < this.gridItems.length; i++) {
      this.resizeGridItem(this.gridItems[i]);
    }
  }

  resizeGridItem(item) {
    var rowHeight = parseInt(window.getComputedStyle(this.el).getPropertyValue('grid-auto-rows'));
    var rowGap = parseInt(window.getComputedStyle(this.el).getPropertyValue('grid-row-gap'));
    var rowSpan = Math.ceil((item.querySelector('.content').getBoundingClientRect().height+rowGap)/(rowHeight+rowGap));
      item.style.gridRowEnd = 'span '+rowSpan;
  }

  resizeInstance(instance) {
    item = instance.elements[0];
    this.resizeGridItem(item);
  }

  observerCallback(mutationList, observer) {
    this.resizeAllGridItems.bind(this)
  }

  urlObserverCallback(mutations) {
    var grid = document.getElementById('entry-cards');
    var items = document.querySelectorAll('.entry-card');
    for(var i = 0; i < items.length; i++) {
      resizeGridItem(items[i]);
    }

    function resizeGridItem(item) {
      var rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
      var rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
      var rowSpan = Math.ceil((item.querySelector('.content').getBoundingClientRect().height+rowGap)/(rowHeight+rowGap));
        item.style.gridRowEnd = 'span '+rowSpan;
    }

  }

  destroy() {
    this.gridObserver.unobserve()
    this.urlObserver.unobserve()
    this.resize.destroy();
  }

}
